import useSWR from "swr";
import API from "../../../axios/instances/API";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data.progress;
};

const BASE_URL =
  "/dashboard/analytics/retail-reports/single-location-progress/?location_id=";

const useSingleLocationProgress = (id) => {
  const { data, error, mutate } = useSWR(`${BASE_URL}${id}`, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useSingleLocationProgress;
